<template>
  <section class="editor-content">
    <h1>
      Contenu : <slot v-if="entity && content">{{ content.document[entity.displayField] }}</slot>
    </h1>

    <div class="container">
      <form action="" @submit.prevent>

        <div class="editor" v-if="entity && content">
          <div class="form-item"
            :class="{ empty: content.document[field.name] === null }"
            v-for="field in entity.fields" :key="field.name">
            <label :for="field.name">{{ entity.fields.find(f => f.name === field.name).label }} *</label>
            <div v-if="!field.type.includes('Array')">

              <content-input v-model="content.document[field.name]" :field="field"/>
            </div>

            <div class="array" v-else>
              <div class="array-element" v-for="(documentField, index) in content.document[field.name]"
                :key="`array-${content.document[field.name]}-${index}`">
                <div class="header" @click="accordeons[`${field.name}-${index}`] = !accordeons[`${field.name}-${index}`]">
                  {{ field.config.items[0].label }} {{ index + 1 }}
                  <i class="icon el-icon-arrow-right"></i>
                </div>
                <div class="content" v-if="accordeons[`${field.name}-${index}`]">
                  <content-input v-model="content.document[field.name][index]" :field="field.config.items[0]"/>

                  <el-button size="small" class="remove" @click="removeItemToFieldArray(field.name, index)"><i class="material-icons">delete</i></el-button>
                </div>
              </div>
              <button type="button" @click="addItemToFieldArray(field.name, field.config.items[0])" class="el-button el-button--small">Ajouter un élément</button>
            </div>
          </div>
        </div>

        <div class="actions">
          <button type="button" @click="unpublish()" v-if="versions && versions.find( v => v.status ==='published' )" class="el-button el-button--small">Dépublier</button>
          <button type="button" @click="saveContent('draft')" class="el-button el-button--small">Sauver en brouillon</button>
          <button type="button" @click="saveContent('published')" class="el-button el-button--small primary">Sauver &amp; Publier</button>
        </div>

      </form>
      <div class="informations">
        <div class="status">
          <h3>Statut</h3>
          <span v-if="entity && content" :class="content.status">{{ status[content.status] }}</span>
        </div>
        <div v-if="langs.length > 0">
          <h3>Langues</h3>
           <span class="langs" v-if="content && langs.length > 0">
            <span :class="{ active: l === lang}" @click="goToLocalizedVersion(l)" v-for="l in langs" :key="l">
              {{ l }}
            </span>
          </span>
        </div>
        <div class="versions">
          <h3>Versions</h3>
          <ul v-if="content">
            <li @click="goToVersion(version.versionId)" v-for="version in versions" :key="version.versionId">
              {{ new Date(version.metadata.createdAt).getDate().toString().padStart(2, '0') }}/{{ new Date(version.metadata.createdAt).getMonth().toString().padStart(2, '0') }}/{{ new Date(version.metadata.createdAt).getFullYear() }}
              {{ new Date(version.metadata.createdAt).getHours().toString().padStart(2, '0') }}:{{ new Date(version.metadata.createdAt).getMinutes().toString().padStart(2, '0') }}

              <span :class="version.status">{{ status[version.status] }}</span>

              <strong v-if="$route.params.versionId === version.versionId">En édtion</strong>
            </li>
          </ul>
        </div>
        <div>
          <h3>Actions</h3>
          <button type="button" @click="duplicateContent()" class="el-button el-button--small">Dupliquer ce contenu</button>
          <button type="button" @click="deleteContent()" class="el-button el-button--small">Supprimer</button>
        </div>
      </div>
    </div>


  </section>
</template>

<script>
import api from '@/services/api';
import ContentInput from '@/components/content/ContentInput.vue';
import InputMedia from '@/components/forms/InputMedia.vue';
import InputRichText from '@/components/forms/InputRichText.vue';
import InputStructuredText from '@/components/forms/InputStructuredText.vue';
import InputDocument from '@/components/forms/InputDocument.vue';
import InputDeltaText from '@/components/forms/InputDeltaText.vue';

export default {
  name: 'editor-content',
  components: {
    InputMedia,
    InputRichText,
    InputStructuredText,
    InputDocument,
    InputDeltaText,
    ContentInput,
  },
  data() {
    return {
      entity: null,
      content: null,
      lang: null,
      langs: [],
      localizedVersions: [],
      versions: [],


      status: {
        published: 'Publié',
        draft: 'Brouillon',
        archived: 'Archivé',
      },

      dialogVisible: {},
      accordeons: {},
    };
  },
  async mounted() {
    await this.fetchData();
  },
  watch: {
    $route: 'fetchData',
  },
  methods: {
    async fetchData() {
      let content = null;
      this.content = null;
      this.entity = await api.getEntity(this.$route.params.spaceId, this.$route.params.entityId);

      if (!this.$route.params.contentId) {
        this.content = {
          locale: 'fr',
          status: 'draft',
          document: {},
        };
      } else {
        content = await api.getVersion(
          this.$route.params.spaceId,
          this.$route.params.entityId,
          this.$route.params.contentId,
          this.$route.params.versionId,
        );
        this.content = {
          locale: content.locale,
          status: content.status,
          document: {},
        };

        this.lang = this.content.locale;
        await this.fetchLocalizedVersions();
        await this.fetchVersions();
      }

      this.entity.fields.forEach((field) => {
        if (!content || !content.document[field.name]) {
          this.$set(this.content.document, field.name, this.getFieldInitValue(field));
        } else {
          this.$set(this.content.document, field.name, content.document[field.name]);
        }
      });

      // init array
      this.entity.fields.forEach((field) => {
        if (field.type.includes('Array')) {
          this.content.document[field.name].forEach((item, index) => {
            this.$set(this.accordeons, `${field.name}-${index}`, true);
          });
        }
      });
    },
    getFieldInitValue(field) {
      let initValue = null;
      if (field.type.includes('Media') || field.type.includes('Document')) initValue = { linkId: null, spaceId: null, type: null };
      else if (field.type.includes('Array') || field.type.includes('RichText') || field.type.includes('StructuredText')) initValue = [];
      else if (field.type.includes('Object')) {
        initValue = {};
        field.config.properties.forEach((objectField) => {
          initValue[objectField.name] = this.getFieldInitValue(objectField);
        });
      }

      return initValue;
    },
    async fetchVersions() {
      this.versions = await api.getVersions(this.$route.params.spaceId, this.$route.params.entityId, this.$route.params.contentId, this.content.locale);
    },
    async fetchLocalizedVersions() {
      const space = await api.getSpace(this.$route.params.spaceId);
      this.langs = space.localeList;
      const versions = {};

      Promise.all(this.langs.map(async (lang) => {
        try {
          versions[lang] = await api.getContent(this.$route.params.spaceId, this.$route.params.entityId, this.$route.params.contentId, lang);
        } catch (error) {
          // log error
        }
      }));

      this.localizedVersions = versions;
    },
    async goToLocalizedVersion(lang) {
      let version = this.localizedVersions[lang];
      if (!version) {
        version = await api.saveVersion(this.$route.params.spaceId, this.$route.params.entityId, this.$route.params.contentId, {
          locale: lang,
          status: 'draft',
          document: this.content.document,
        });
      }

      this.$router.push({
        name: 'editor-content',
        params: {
          spaceId: this.$route.params.spaceId,
          entityId: this.$route.params.entityId,
          contentId: this.$route.params.contentId,
          versionId: version.versionId,
        },
      });
    },
    async goToVersion(versionId) {
      try {
        await this.$confirm('Voulez-vous charger cette ancienne version (les changements actuels seront perdus) ?', 'Versions');
        this.$router.push({
          name: 'editor-content',
          params: {
            spaceId: this.$route.params.spaceId,
            entityId: this.$route.params.entityId,
            contentId: this.$route.params.contentId,
            versionId,
          },
        });
      } catch (error) {
        // Rien à faire
      }
    },
    async saveContent(status) {
      this.content.status = status;
      await this.saveData(this.content);
    },
    async saveData(data) {
      if (!this.$route.params.contentId) {
        await this.createData(data);
      } else {
        await this.updateData(data);
      }
    },
    async updateData(data) {
      try {
        const content = await api.saveVersion(this.$route.params.spaceId, this.$route.params.entityId, this.$route.params.contentId, {
          locale: data.locale,
          status: data.status,
          document: data.document,
        });
        this.$notify.success({
          title: 'Contenu enregistré',
          message: 'Contenu enregistré',
        });
        this.$router.push({
          name: 'editor-content',
          params: {
            spaceId: this.$route.params.spaceId,
            entityId: this.$route.params.entityId,
            contentId: this.$route.params.contentId,
            versionId: content.versionId,
          },
        });
      } catch (e) {
        let message = 'Impossible d‘enregistrer ';
        if (e.response.data.message) {
          this.entity.fields.forEach((field) => {
            if (e.response.data.message.includes(field.name)) message += `le champ "${field.label}" contient une erreur.`;
          });
        }
        this.$notify.error({
          title: 'Erreur',
          message,
        });
      }
    },
    async createData(data) {
      try {
        const content = await api.createContent(this.$route.params.spaceId, this.$route.params.entityId, {
          locale: data.locale,
          status: data.status,
          document: data.document,
        });
        this.$notify.success({
          title: 'Contenu enregistré',
          message: 'Contenu enregistré',
        });
        this.$router.push({
          name: 'editor-content',
          params: {
            spaceId: this.$route.params.spaceId,
            entityId: this.$route.params.entityId,
            contentId: content.contentId,
            versionId: content.versionId,
          },
        });
      } catch (e) {
        let message = 'Impossible d‘enregistrer ';
        if (e.response.data.message) {
          this.entity.fields.forEach((field) => {
            if (e.response.data.message.includes(field.name)) message += `le champ "${field.label}" contient une erreur.`;
          });
        }
        this.$notify.error({
          title: 'Erreur',
          message,
        });
      }
    },
    async duplicateContent() {
      try {
        await this.$confirm('Voulez-vous dupliquer ce contenu ?', 'Duplication de contenu');
        const content = await api.createContent(this.$route.params.spaceId, this.$route.params.entityId, {
          locale: this.content.locale,
          status: this.content.status,
          document: this.content.document,
        });
        this.$notify.success({
          title: 'Contenu dupliqué',
          message: 'Contenu dupliqué avec succès',
        });
        this.$router.push({
          name: 'editor-content',
          params: {
            spaceId: this.$route.params.spaceId,
            entityId: this.$route.params.entityId,
            contentId: content.contentId,
            versionId: content.versionId,
          },
        });
      } catch (e) {
        this.$notify.error({
          title: 'Erreur',
          message: 'Attention votre contenu n’a pas pu être dupliqué',
        });
      }
    },
    async unpublish() {
      const publishedVersion = this.versions.find(v => v.status === 'published');

      if (publishedVersion) {
        await api.updateVersion(
          this.$route.params.spaceId,
          this.$route.params.entityId,
          this.$route.params.contentId,
          publishedVersion.versionId, {
            status: 'archived',
          },
        );
        await this.fetchData();

        this.$notify.success({
          title: 'Dépublication réussie',
          message: 'Ce contenu n’est plus publié dans cette langue.',
        });
      }
    },
    async deleteContent() {
      try {
        await this.$confirm('Voulez-vous supprimer ce contenu ? Cette action sera définitive.', 'Suppression');
        await api.deleteContent(
          this.$route.params.spaceId,
          this.$route.params.entityId,
          this.$route.params.contentId,
        );
        this.$notify.success({
          title: 'Suppression réussie',
          message: `Le contenu "${this.content.document[this.entity.displayField]}" a été supprimé.`,
        });
        this.$router.push({
          name: 'editor-contents',
          params: {
            spaceId: this.$route.params.spaceId,
            entityId: this.$route.params.entityId,
          },
        });
      } catch (error) {
        // Rien
      }
    },
    addItemToFieldArray(fieldName, childField) {
      const item = this.getFieldInitValue(childField);
      const index = this.content.document[fieldName] ? this.content.document[fieldName].length : 0;
      this.$set(this.content.document[fieldName], index, item);
      this.$set(this.accordeons, `${fieldName}-${index}`, true);
    },
    async removeItemToFieldArray(fieldName, index) {
      try {
        await this.$confirm('Voulez-vous supprimer ce élément de la liste ?', 'Suppression');
        this.$delete(this.content.document[fieldName], index);
      } catch (error) {
        // Rien
      }
    },
  },
};
</script>

<style lang="sass">
.editor-content
  padding-top: 50px
  h1
    position: fixed
    top: 26px
    left: 200px
    right: 0
    padding: 1.5rem 2rem 1.2rem
    background: #FAFAFA
    z-index: 1800

  .container
    display: flex
    padding-top: 20px
    justify-content: space-between
    form
      flex: 1
    .informations
      margin: 1rem 0 1rem 1rem
      padding: 0.5rem 1.2rem
      width: 300px
      background: #EAEAEA
      text-align: left
      border-radius: 4px
      h3
        font-size: 0.8rem
        color: #999999
      > div
        margin-bottom: 2rem

  .status
    span
      padding: 0.4rem 0.8rem 0.3rem
      border-radius: 4px
      color: white
      font-size: 0.9rem
      text-transform: uppercase
      &.draft
        background: #f58d2c
        border-color: #f58d2c
      &.published
        background: #001861
        border-color: #001861
      &.archived
        background: #AAAAAA
        border-color: #AAAAAA

  .langs
    span
      margin-right: 0.2rem
      padding: 0.4rem 0.8rem 0.3rem
      border-radius: 4px
      background: #CCCCCC
      cursor: pointer
      font-size: 0.7rem
      font-weight: bold
      text-transform: uppercase
      border: 2px solid transparent
      transition: all ease-in-out 0.2s
      &:hover
        background: white
    .active
      opacity: 1
      color: #f58d2c
      background: white
      border-color: #f58d2c

  .versions
    ul
      margin: 0
      padding-left: 0
      max-height: 250px
      overflow-y: scroll
    li
      margin: 0.2rem 0
      padding: 0 0.2rem
      font-size: 0.6rem
      list-style-type: none
      border-left: 2px solid white
      &:hover
        color: #001861
        cursor: pointer
      span
        margin: 0 0.1rem
        &.published
          padding: 0.15rem 0.5rem 0.1rem
          background: #ff3c48
          color: white
          border-radius: 4px
      strong
        margin: 0 0.1rem
        padding: 0.15rem 0.5rem 0.1rem
        background: #001761
        color: white
        border-radius: 4px

  .form-item
    justify-content: left
    margin: 1rem 0
    padding: 1rem
    text-align: left
    border-left: 4px solid #001861
    background: white

    label
      padding: 0 0 0.5rem 0
      display: block
      text-align: left
      font-size: 0.8rem
      font-weight: bold
      color: #AAAAAA
      text-transform: capitalize

    .array
      .array-element
        position: relative
        display: block
        margin: 0 0 0.5rem 0
        padding: 0.2rem
        border: 1px solid #CACACA
        border-radius: 4px
        background: white
        overflow: hidden
        .icon
          position: absolute
          top: 16px
          right: 28px
        .remove
          position: absolute
          top: 2px
          right: 10px
          transform: scale(0.7)
        .add
          position: absolute
          top: 0
          left: 0
          right: 0
          bottom: 0
          display: flex
          align-items: center
          padding: 1rem
          background: #EAEAEA
          font-size: 0.8rem
          justify-content: center

        .header
          padding: 0.6rem
          background: #FAFAFA
          font-size: 0.8rem
          cursor: pointer

        .content
          padding: 0.2rem 0.5rem
          label
            margin-top: 0.5rem
            padding-bottom: 0.2rem
            font-size: 0.7rem


  .actions
    position: fixed
    top: 48px
    right: 15px
    padding: 1rem
    z-index: 1850
    background: #FAFAFA

    .is-active
      &.draft .el-radio-button__inner
        background: #f58d2c
        border-color: #f58d2c
      &.published .el-radio-button__inner
        background: #001861
        border-color: #001861
      &.archived .el-radio-button__inner
        background: #AAAAAA
        border-color: #AAAAAA
    .el-button
      margin-left: 10px
      &.primary
        background: #ff3c48
        color: white
</style>

